import React from 'react';
import { pick } from 'lodash';

import { Checkbox } from 'shared/components';
import FilterItem from '../../components/FilterItem';

const FilterByLastConversationStatus = ({ statuses, setFilterByConversationStatus, ...rest }) => {
  const filterItemProps = pick(rest, ['expanded', 'onChange', 'label', 'description']);

  return (
    <FilterItem { ...filterItemProps }>
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        { statuses.map(({ key, label, checked }) => (
          <div style={{ margin: '10px 0' }} key={ key }>
            <Checkbox
              id={ key }
              checked={ checked }
              tabIndex={ rest.expanded ? 0 : -1 }
              onClick={ () => setFilterByConversationStatus(key) }
              label={ label }
            />
          </div>
        )) }
      </div>
    </FilterItem>
  );
};

export default FilterByLastConversationStatus;
